// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacyPage {
  background: #F6F8FC;
}

.privacyHero {
  padding: 90px 20px;
  background: linear-gradient(135deg, #04b0fab4, rgba(44,116,250,0.85));
  color: white;
  text-align: center;
}

.privacyHero h1 {
  font-size: 42px;
  margin-bottom: 10px;
}


.privacyContent {
  padding: 70px 20px 100px;
}



.narrow {
  max-width: 850px;
}

.privacyContent h2 {
  margin-top: 40px;
  margin-bottom: 16px;
  font-size: 24px;
  color: #0D1B2A;
}

.privacyContent h3 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 18px;
  color: #2c74fa;
}

.privacyContent p {
  margin-bottom: 16px;
  line-height: 1.7;
  color: #333;
}

.privacyContent ul {
  margin-left: 20px;
  margin-bottom: 20px;
}

.privacyContent li {
  margin-bottom: 8px;
}

/* Responsive */

@media (max-width: 600px) {
  .privacyHero h1 {
    font-size: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/Privacy.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qEAAqE;EACrE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,wBAAwB;AAC1B;;;;AAIA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,eAAe;;AAEf;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".privacyPage {\n  background: #F6F8FC;\n}\n\n.privacyHero {\n  padding: 90px 20px;\n  background: linear-gradient(135deg, #04b0fab4, rgba(44,116,250,0.85));\n  color: white;\n  text-align: center;\n}\n\n.privacyHero h1 {\n  font-size: 42px;\n  margin-bottom: 10px;\n}\n\n\n.privacyContent {\n  padding: 70px 20px 100px;\n}\n\n\n\n.narrow {\n  max-width: 850px;\n}\n\n.privacyContent h2 {\n  margin-top: 40px;\n  margin-bottom: 16px;\n  font-size: 24px;\n  color: #0D1B2A;\n}\n\n.privacyContent h3 {\n  margin-top: 20px;\n  margin-bottom: 10px;\n  font-size: 18px;\n  color: #2c74fa;\n}\n\n.privacyContent p {\n  margin-bottom: 16px;\n  line-height: 1.7;\n  color: #333;\n}\n\n.privacyContent ul {\n  margin-left: 20px;\n  margin-bottom: 20px;\n}\n\n.privacyContent li {\n  margin-bottom: 8px;\n}\n\n/* Responsive */\n\n@media (max-width: 600px) {\n  .privacyHero h1 {\n    font-size: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
